intra_module.directive('likeDetails', function() {
	return {
		restrict:    'E',
		templateUrl: 'directives/conversations/like-details/template.html',

		scope: {
			like_list: '=likeList',
			type:      '@type'
		}
	};
});
